import usePodcastFormStepsStore from 'store/usePodcastFormStepsStore'

export const UploadFormHeader = () => {
  const { currentStepIndex } = usePodcastFormStepsStore()

  const messages = [
    "Upload your episode via URL (YouTube, Reddit, TikTok, Instagram, Facebook, or Twitter/X), RSS feed, or file upload. We'll use this to generate a transcript and build your episode content.",
    'Fill in a few details about your episode so we can tune the content to your audience.',
    'Review your episode and submit.',
  ]
  return (
    <div className="mb-5 border-b border-gray-200 pb-5">
      <h3 className="text-base font-semibold leading-6 text-gray-900">
        Upload a new episode
      </h3>
      <p className="mt-2 max-w-4xl text-sm text-gray-500">
        {messages[currentStepIndex]}
      </p>
    </div>
  )
}
